import { useQuery } from '@tanstack/react-query';
import { Select, type SelectProps } from 'antd';
import { getProvincesDropdown } from 'src/apis/master_data/province.api';

export default function ProvinceSelect({
  value,
  style,
  allowClear = true,
  onChange,
  placeholder,
  disabled
}: SelectProps) {
  const provinceQuery = useQuery({
    queryKey: ['provinceDropdown'],
    queryFn: () => getProvincesDropdown(),
    staleTime: 60 * 1000
  });

  return (
    <Select
      allowClear={allowClear}
      value={provinceQuery.isFetching ? undefined : value}
      style={{ width: '100%', ...style }}
      placeholder={placeholder || 'Chọn tỉnh/thành phố'}
      disabled={disabled}
      onChange={onChange}
      options={provinceQuery.data?.data.map((data) => ({
        value: data.id,
        label: data.name,
        data: data
      }))}
      showSearch
      filterOption={(input, option) => (option?.label?.toString() ?? '').toLowerCase()?.includes(input.toLowerCase())}
      loading={provinceQuery.isFetching}
    />
  );
}
